import type { ReactElement } from 'react'

import styles from './spinner.module.scss'

export type SpinnerProps = {
  /** Said out loud and shown next to the disc. Default: 'Cargando…'. */
  label?: string
  /** `page` fills the viewport — for a route guard waiting on the session. */
  size?: 'inline' | 'page'
}

/**
 * "We are loading it", and visibly not `EmptyState` or `ErrorState`. `role
 * status` + `aria-live="polite"` is what makes it findable in a spec
 * (`getByRole('status')`) and audible to a screen reader.
 */
export const Spinner = ({ label = 'Cargando…', size = 'inline' }: SpinnerProps): ReactElement => (
  <div
    className={[styles.spinner, size === 'page' ? styles['spinner--page'] : ''].filter(Boolean).join(' ')}
    role="status"
    aria-live="polite"
  >
    <span className={styles.spinner__disc} aria-hidden="true" />
    <span className={styles.spinner__label}>{label}</span>
  </div>
)
